<script>
    import {onMount, tick} from "svelte";

    export let content;
    export let idx = 0;

    export let wrap_p = true;

    let editor;

    export function focus() {
        editor.focus()
    }

    function createEditor(node) {
        node.setAttribute('contenteditable', true);

        let config = {
            extraPlugins: "sharedspace,image2,save,highlight",

            removePlugins: "image",
            sharedSpaces: {
                top: 'toolbarTop'
            },
            extraAllowedContent: 'img[src,alt,width,height]{float,width,height,margin}',
            removeDialogTabs: 'image2:advanced;image2:Link',
            toolbar: [
                {name: "basicstyles", items: ["Bold", "Italic", "Underline", "-", "RemoveFormat", "Format"]},
                {name: "save", items: ['save']},
                {name: 'paragraph', items: [ 'NumberedList','BulletedList','-','Outdent','Indent', '-','JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock']},
                {name: 'links', items: [ 'Link','Unlink' ] },
                {name: 'colors', items : [ 'TextColor', 'highlight', 'removeHighlight' ] } , //,'BGColor' ] },
                {name: 'images', items: ['Image']},
                {name: 'source', items: ["Source"]}
            ],
            format_tags: 'h1;h2;h3;p',
            image2_captionedClass: 'image-captioned',
            image2_alignClasses: ['image-left', 'image-center', 'image-right'],

            filebrowserUploadUrl: "/api/file_manager/upload/",
            filebrowserBrowseUrl: "/api/file_manager/"
        }

        if (!wrap_p) {
            config.enterMode = CKEDITOR.ENTER_BR;
        }

        CKEDITOR.plugins.addExternal('highlight', '/public/assets/plugins/highlight/')

        editor = CKEDITOR.inline(node, config);

        editor.setData(content);

        editor.on('change', (evt) => {
            content = evt.editor.getData();
        });

        return {
            update: (content) => {
                if (content != editor.getData())
                    editor.setData(content)
            }
        }
    }

    onMount(() => {
        CKEDITOR.disableAutoInline = true;
    })
</script>

<div id="editor_{idx}" class="editor" use:createEditor={content} data-idx={idx}></div>